// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-dashboard h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

.exercises-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.exercise-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
}

.exercise-card:not(.locked):hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.exercise-card.locked {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  opacity: 0.7;
}

.locked-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  color: #6c757d;
}

.lock-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.locked-message p {
  margin: 0;
  font-size: 0.95rem;
}

.badge-locked {
  background-color: #6c757d;
}

.exercise-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.exercise-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #2c3e50;
}

.exercise-description {
  color: #7f8c8d;
  margin-bottom: 1rem;
  flex-grow: 1;
}

.exercise-progress {
  margin-bottom: 1rem;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2ecc71);
  transition: width 0.3s;
}

.progress-text {
  font-size: 0.875rem;
  color: #7f8c8d;
}

.quiz-info {
  font-size: 0.875rem;
  color: #7f8c8d;
  margin-bottom: 1rem;
}

.exercise-actions {
  display: flex;
  gap: 0.5rem;
}

.exercise-actions .btn {
  flex: 1 1;
  text-align: center;
  text-decoration: none;
}

.exercise-completed-note {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1px solid #cce8d3;
  border-radius: 6px;
  background: #f1faf3;
  color: #267344;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/student/StudentDashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".student-dashboard h1 {\r\n  margin-bottom: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.exercises-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\r\n  gap: 1.5rem;\r\n}\r\n\r\n.exercise-card {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.exercise-card:not(.locked):hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.exercise-card.locked {\r\n  background: #f8f9fa;\r\n  border: 2px dashed #dee2e6;\r\n  opacity: 0.7;\r\n}\r\n\r\n.locked-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem 1rem;\r\n  text-align: center;\r\n  color: #6c757d;\r\n}\r\n\r\n.lock-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.locked-message p {\r\n  margin: 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.badge-locked {\r\n  background-color: #6c757d;\r\n}\r\n\r\n.exercise-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.exercise-header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.exercise-description {\r\n  color: #7f8c8d;\r\n  margin-bottom: 1rem;\r\n  flex-grow: 1;\r\n}\r\n\r\n.exercise-progress {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 8px;\r\n  background-color: #e9ecef;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.progress-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #3498db, #2ecc71);\r\n  transition: width 0.3s;\r\n}\r\n\r\n.progress-text {\r\n  font-size: 0.875rem;\r\n  color: #7f8c8d;\r\n}\r\n\r\n.quiz-info {\r\n  font-size: 0.875rem;\r\n  color: #7f8c8d;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.exercise-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.exercise-actions .btn {\r\n  flex: 1;\r\n  text-align: center;\r\n  text-decoration: none;\r\n}\r\n\r\n.exercise-completed-note {\r\n  width: 100%;\r\n  padding: 0.7rem 1rem;\r\n  border: 1px solid #cce8d3;\r\n  border-radius: 6px;\r\n  background: #f1faf3;\r\n  color: #267344;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
